import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

interface Props {
    children: React.ReactNode;
}

export default function AppLayout({ children }: Props) {
    return (
        <div className="min-h-screen bg-[#F7F4F8]">
            <Sidebar />
            <div className="lg:pl-[260px]">
                <Header />
                <main className="min-h-[calc(100dvh-64px)] w-full min-w-0 overflow-x-hidden px-3 py-5 sm:min-h-[calc(100dvh-72px)] sm:px-6 sm:py-6 lg:px-8 lg:py-8">
                    {children}
                </main>
            </div>
        </div>
    );
}
